import { yupResolver } from '@hookform/resolvers/yup';
import { FormControl, Grid, Typography, Tooltip } from '@mui/material';
import { ICollaboratorInputModel } from 'inputModels';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ICollaboratorViewModel, IProfileViewModel } from 'viewModels';
import * as yup from 'yup';
import { v4 as uuid } from 'uuid';
import { useTheme } from 'styled-components';
import { ReactComponent as Iconedit } from '../../../assets/icons/Iconedit.svg';
import { ReactComponent as ExpandArrowIcon } from '../../../assets/icons/iconExpandArrow.svg';
import { ReactComponent as Icontrash } from '../../../assets/icons/IconTrashCan.svg';
import { Button, DropdownCollaborator, Input, InputFilter, NavHeader } from '../../../components';
import { MenuOptionLeftCompany } from '../../../components/MenuOptionLeft/Company';
import { ModalDeleteCollaborator } from '../../../components/Modals/ModalDeleteCollaborator';
import { ModalEditCollaborator } from '../../../components/Modals/ModalEditCollaborator';
import { SelectControled } from '../../../components/SelectControled';
import { useApp, useAuth, useDepartments, useProfile } from '../../../context';
import { useBranch } from '../../../context/branch';
import { useCollaborator } from '../../../context/collaborator';
import { CompanyController } from '../../../controller/CompanyController';
import { sendEmail } from '../../../controller/EmailController';
import { ReactComponent as IconExcelReport } from '../../../assets/icons/icon-excel-report.svg';
import useClickOutside from '../../../hooks/useClickOutside';
import { ProfileType, TutorialType, labelProfileType } from '../../../types/enums';
import { encryptPassword } from '../../../utils/encryptPassword';
import { generateRandomPassword } from '../../../utils/generateRandomPassword';
import { Body, Container, Content, ContentSummary } from './styles';
import { useAlert } from '../../../hooks/useAlert';
import { SelectProfileCollaborator } from '../../../components/SelectProfileCollaborator';
import { useReport } from '../../../context/report';
import TitlePage from '../../../components/TitlePage';
import JoyrideTour from '../../../components/JoyrideTour';
import { useConfig } from '../../../context/configCustom';

type OrderCollaborator =
  | 'alphabeticalOrder'
  | 'profile'
  | 'department'
  | 'contractor'
  | 'provider'
  | 'both';

type FilterCollaborator = {
  id: OrderCollaborator;
  value: string;
};

export function Collaborators() {
  const app = useApp();
  const alert = useAlert();
  const { isGeneratingReport, handleGenerateCollaboratorReport } = useReport();
  const { user } = useAuth();
  const { pathResourceEmail } = useConfig();
  const { colors } = useTheme();
  const { branches } = useBranch();
  const { profiles } = useProfile();
  const { departments } = useDepartments();
  const { collaborators, setCollaborators, isLoadingCollaborators, setEnableCollaboratorsLoad } =
    useCollaborator();
  const [profileSelectedId, setProfileSelectedId] = useState<string>('');
  const [departmentSelectedId, setDepartmentSelectedId] = useState<string>('');
  const [branchSelectedId, setBranchSelectedId] = useState<string>('');
  const [collaboratorSelected, setCollaboratorSelected] = useState<ICollaboratorViewModel>();
  const [isOpenDeleteCollaborator, setIsOpenDeleteCollaborator] = useState(false);
  const [isOpenEditCollaborator, setIsOpenEditCollaborator] = useState(false);
  const [viewProfiles, setViewProfiles] = useState(false);
  const [searchProfile] = useState<string>('');
  const [typeProfileSearchSelected] = useState<ProfileType>();
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState<OrderCollaborator>();
  const [, setProfileResultItem] = useState<IProfileViewModel[]>([]);
  const [runningTutorial, setRunningTutorial] = useState(false);
  const [collaboratorToTutorial] = useState<ICollaboratorViewModel[]>([
    {
      id: uuid(),
      companyId: uuid(),
      email: 'email@tutorial.com.br',
      firstName: 'Colaborador Tutorial',
      branchName: 'Filial Tutorial',
      departmentName: 'Departamento Tutorial',
      profileName: 'Perfil Tutorial',
      profileType: ProfileType.APPROVER,
    },
  ]);

  const steps = [
    {
      target: '#start-item',
      content:
        'Os colaboradores são os funcionários da sua empresa, a partir desse menu é possível adicionar novos colaboradores, editar ou visualizar os colaboradores já cadastrados.',
      disableBeacon: true,
    },
    {
      target: '#prev-add-collaborator',
      content:
        'Para adicionar um colaborador, é necessário que o perfil, a filial e o departamento ao qual ele pertence já estejam cadastrados.',
    },
    {
      target: '#name-new-collaborator',
      content: 'Informe o nome do colaborador.',
    },
    {
      target: '#mail-new-collaborator',
      content: 'Informe o e-mail do colaborador.',
    },
    {
      target: '#profile-new-collaborator',
      content: 'Selecione o perfil do colaborador.',
    },
    {
      target: '#branch-new-collaborator',
      content: 'Selecione a filial do colaborador.',
    },
    {
      target: '#department-new-collaborator',
      content: 'Selecione o departamento do colaborador.',
    },
    {
      target: '#add-new-collaborator',
      content: 'Clique em adicionar para finalizar o cadastro.',
    },
    {
      target: '#search',
      content:
        'Para localizar um colaborador, clique na lupa e pesquise por qualquer informação relacionada a ele.',
    },
    {
      target: '#order',
      content:
        'Você pode ordenar os colaboradores pelo campo desejado, basta selecioná-lo na lista de opções.',
    },
    {
      target: '#edit-collaborator',
      content:
        'Para editar um colaborador basta clicar no ícone de lápis e preencher os campos necessários.',
    },
    {
      target: '#delete-collaborator',
      content:
        'Para excluir um colaborador basta clicar na lixeira e confirmar clicando no botão excluir.',
    },
  ];

  const [defaultValues] = useState({
    name: '',
    email: '',
    typeProfile: '',
    department: '',
    branch: '',
  });

  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(() => {
    setViewProfiles(false);
  }, ref);

  const filtersCollaborator: FilterCollaborator[] = [
    { id: 'alphabeticalOrder', value: 'Ordem alfabética' },
    { id: 'profile', value: 'Perfil' },
    { id: 'department', value: 'Departamento' },
    { id: 'contractor', value: 'Contratante' },
    { id: 'provider', value: 'Prestador' },
    { id: 'both', value: 'Ambos' },
  ];

  const handleProfileSearch = useCallback(
    (value: string) => {
      if (value === '' && typeProfileSearchSelected === undefined) return;

      if (typeProfileSearchSelected === undefined) {
        setProfileResultItem(
          profiles.filter((p) => p.name?.toLowerCase().startsWith(value.toLowerCase())),
        );
      } else {
        setProfileResultItem(
          profiles.filter(
            (p) =>
              p.name?.toLowerCase().startsWith(value.toLowerCase()) &&
              p.type === Number(typeProfileSearchSelected),
          ),
        );
      }
    },
    [profiles, typeProfileSearchSelected],
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      handleProfileSearch(searchProfile);
    }, 1000);
    return () => clearTimeout(timer);
  }, [handleProfileSearch, searchProfile]);

  const collaboratorSchema = yup.object().shape({
    name: yup.string().required('O campo nome é obrigatório!'),
    email: yup.string().required('O campo e-mail é obrigatório').email('Digite um e-mail válido'),
    typeProfile: yup.string().required('O campo perfil é obrigatório'),
    branch: yup.string().required('O campo filial é obrigatório'),
    department: yup.string().required('O campo departamento é obrigatório'),
  });

  const {
    control,
    reset,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    setError,
  } = useForm({
    defaultValues,
    resolver: yupResolver(collaboratorSchema),
  });

  const handleCreateCollaborator = async () => {
    if (runningTutorial) {
      alert.show({
        message: 'Isso é apenas uma demonstração! O colaborador não será cadastrado.',
        type: 'success',
      });
      return;
    }
    if (!pathResourceEmail) {
      alert.show({ message: 'Erro ao enviar e-mail!', type: 'error' });
      return;
    }
    const isExists = collaborators.some((c) => c.email === getValues('email'));
    if (isExists) {
      setError('email', { message: 'E-mail já cadastrado' });
      return;
    }
    app.setLoading(true);
    const password = generateRandomPassword();
    const collaborator: ICollaboratorInputModel = {
      email: getValues('email'),
      firstName: getValues('name'),
      companyId: user?.id,
      profileId: getValues('typeProfile'),
      departmentId: getValues('department'),
      branchId: getValues('branch'),
      password: encryptPassword(password),
    };
    await CompanyController.createCollaborator(collaborator)
      .then((response) => {
        const newCollaborator = response.data as ICollaboratorViewModel;
        setCollaborators((state) => [...state, newCollaborator]);
        reset();
        setBranchSelectedId('');
        setDepartmentSelectedId('');
        setProfileSelectedId('');
        sendEmail({
          type: 'confirmEmailColaborator',
          to: newCollaborator.email,
          value: password,
          pathResource: pathResourceEmail,
          options: {
            companyName: `${user?.firstName} ${user?.lastName ?? ''}`,
          },
        });
        alert.show({ message: 'Colaborador adicionado com sucesso!', type: 'success' });
      })
      .catch((error) => {
        if (error.response.data === 'EMAIL_ALREADY_EXISTS') {
          setError('email', { message: 'E-mail já cadastrado' });
        } else {
          alert.show({ message: 'Erro ao adicionar colaborador!', type: 'error' });
        }
      })
      .finally(() => {
        app.setLoading(false);
      });
  };

  const handleRemoveCollaborator = () => {
    if (runningTutorial) {
      alert.show({
        message: 'Isso é apenas uma demonstração! O colaborador não será excluído.',
        type: 'success',
      });
      return;
    }
    setCollaborators((state) => state.filter((c) => c.email !== collaboratorSelected?.email));
    setIsOpenDeleteCollaborator(false);
  };
  const handleUpdateCollaborator = () => {
    if (runningTutorial) {
      alert.show({
        message: 'Isso é apenas uma demonstração! O colaborador não será atualizado.',
        type: 'success',
      });
    }
  };
  const searchCollaborators = useCallback(
    (data: ICollaboratorViewModel[]) => {
      return data.filter(
        (c) =>
          c.firstName.toLowerCase().includes(search) ||
          c.departmentName?.toLowerCase().includes(search) ||
          c.profileName?.toLowerCase().includes(search) ||
          c.email.toLowerCase().includes(search) ||
          labelProfileType[c.profileType as unknown as ProfileType].toLowerCase().includes(search),
      );
    },
    [search],
  );
  const handleGenerateReport = () => {
    if (isGeneratingReport) return;
    alert.show({ message: 'Gerando relatório... Aguarde', type: 'success' });
    handleGenerateCollaboratorReport(user.id);
  };

  const filteredCollaborators = useMemo(() => {
    let data: ICollaboratorViewModel[] = [];
    switch (filter) {
      case 'alphabeticalOrder':
        data = collaborators.sort((a, b) =>
          a.firstName > b.firstName ? 1 : b.firstName > a.firstName ? -1 : 0,
        );
        break;
      case 'profile': {
        data = collaborators.sort(
          (a, b) =>
            Number(b.profileType) - Number(a.profileType) ||
            (a.firstName > b.firstName ? 1 : b.firstName > a.firstName ? -1 : 0),
        );
        break;
      }
      case 'department':
        data = collaborators
          .filter((c) => !!c.departmentName)
          .sort((a, b) => {
            if (a.departmentName && b.departmentName) {
              if (a.departmentName > b.departmentName) {
                return 1;
              }
              if (a.departmentName < b.departmentName) return -1;
              return 0;
            }

            if (a.departmentName || b.departmentName) {
              if (a.departmentName) {
                return -1;
              }
              return 1;
            }

            return 0;
          });
        break;

      default:
        data = collaborators;
        break;
    }

    return (search ? searchCollaborators(data) : data) || [];
  }, [filter, search, searchCollaborators, collaborators]);

  useEffect(() => {
    app.setLoading(isLoadingCollaborators);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingCollaborators]);

  useEffect(() => {
    setEnableCollaboratorsLoad(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!user?.tutorialProgress?.some((p) => p === TutorialType.COLLABORATOR)) {
      setRunningTutorial(true);
    }
  }, [user.tutorialProgress]);
  return (
    <>
      <NavHeader typeHeader="company" />
      <JoyrideTour
        type={TutorialType.COLLABORATOR}
        steps={steps}
        run={runningTutorial}
        onCallbackFinished={() => setRunningTutorial(false)}
      />
      <Body>
        <MenuOptionLeftCompany />
        <Container>
          <div className="EnunciateAddCollaborator">
            <TitlePage
              title="Colaboradores"
              onRequestOpen={() => setRunningTutorial(true)}
              id="start-item"
            />
            <div className="searchExportContent">
              <Button
                text="Extrair relatório"
                LeftComponent={IconExcelReport}
                styleLeftComponent={{ fill: colors.tertiary_500 }}
                style={{ fontSize: '1.20rem', display: 'flex', alignItems: 'center' }}
                dimensions={{
                  width: '100%',
                  height: '1.25rem',
                }}
                positionLeftElement={5}
                disabled={isGeneratingReport}
                border={{ color: 'tertiary_500', width: 1 }}
                color="tertiary_500"
                textHoverColor="tertiary_500"
                backgroundHoverColor="background_white"
                onClick={handleGenerateReport}
              />
            </div>
          </div>
          <Content active={viewProfiles}>
            <div className="AddCollaborators">
              <div className="InputNameEmail">
                <Input
                  name="name"
                  control={control}
                  type="text"
                  placeholder="Nome"
                  id="name-new-collaborator"
                  errorText={errors.name?.message}
                  variant="standard"
                  fullWidth
                  error={!!errors.name}
                />
                <Input
                  name="email"
                  control={control}
                  type="text"
                  placeholder="E-mail"
                  id="mail-new-collaborator"
                  errorText={errors.email?.message}
                  variant="standard"
                  fullWidth
                  error={!!errors.email}
                />
              </div>
              <div className="AddCheckedTypeProfile" id="prev-add-collaborator">
                <div className="TypeProfile">
                  <div className="divDropDownList">
                    <FormControl fullWidth>
                      <p>Perfil</p>
                      <SelectProfileCollaborator
                        name="typeProfile"
                        control={control}
                        value={profileSelectedId}
                        id="profile-new-collaborator"
                        onChange={(e) => {
                          setValue('typeProfile', e.target.value as string);
                          setProfileSelectedId(e.target.value as string);
                        }}
                        error={!!errors.typeProfile}
                        errorText={errors.typeProfile?.message}
                        placeholderTitle="Selecione"
                        operators={profiles
                          .filter((p) => p.type === ProfileType.OPERATOR)
                          .map((profile) => ({ id: profile.id, name: profile.name }))}
                        approvers={profiles
                          .filter((p) => p.type === ProfileType.APPROVER)
                          .map((profile) => ({ id: profile.id, name: profile.name }))}
                        requesters={profiles
                          .filter((p) => p.type === ProfileType.REQUESTER)
                          .map((profile) => ({ id: profile.id, name: profile.name }))}
                        financers={profiles
                          .filter((p) => p.type === ProfileType.FINANCIAL)
                          .map((profile) => ({ id: profile.id, name: profile.name }))}
                      />
                    </FormControl>
                  </div>
                  <div className="divDropDownList">
                    <FormControl fullWidth>
                      <p>Filial</p>
                      <SelectControled
                        name="branch"
                        control={control}
                        value={branchSelectedId}
                        id="branch-new-collaborator"
                        onChange={(e) => {
                          setValue('branch', e.target.value as string);
                          setBranchSelectedId(e.target.value as string);
                        }}
                        displayEmpty
                        error={!!errors.branch}
                        itens={branches.map((branch) => ({ id: branch.id, value: branch.name }))}
                        placeholderTitle="Selecione"
                        errorText={errors.branch?.message}
                      />
                    </FormControl>
                  </div>
                  <div className="divDropDownList">
                    <FormControl fullWidth>
                      <p>Departamento</p>
                      <SelectControled
                        name="department"
                        control={control}
                        value={departmentSelectedId}
                        id="department-new-collaborator"
                        onChange={(e) => {
                          setValue('department', e.target.value as string);
                          setDepartmentSelectedId(e.target.value as string);
                        }}
                        displayEmpty
                        IconComponent={ExpandArrowIcon}
                        itens={departments
                          .filter((d) => d.isActive)
                          .map((department) => ({ id: department.id, value: department.name }))}
                        placeholderTitle="Selecione"
                        error={!!errors.department}
                        errorText={errors.department?.message}
                      />
                    </FormControl>
                  </div>
                </div>
              </div>
              <div className="cntButtonAdd">
                <Button
                  text="Adicionar"
                  id="add-new-collaborator"
                  dimensions={{ width: '13rem', height: '2.25rem' }}
                  onClick={handleSubmit(handleCreateCollaborator)}
                />
              </div>
            </div>
          </Content>
          <ContentSummary>
            <div className="SummaryEnunciate">
              <p>Cadastrados</p>
              <div className="divFiltrar">
                <div>
                  <InputFilter
                    elementId="search"
                    onSearch={(text) => {
                      setSearch(
                        text
                          .split(' ')
                          .map((item) => item.trim())
                          .filter((item) => !!item)
                          .join(' ')
                          .toLowerCase()
                          .trim(),
                      );
                    }}
                  />
                </div>
                <div>
                  <DropdownCollaborator
                    placeholderTitle="Selecione o filtro"
                    itens={filtersCollaborator}
                    elementId="order"
                    onChange={(value) => setFilter(value as OrderCollaborator)}
                  />
                </div>
              </div>
            </div>
            {!runningTutorial ? (
              collaborators.length ? (
                <>
                  <div className="SummaryControllerCollaborators">
                    {filteredCollaborators.map((collaborator) => (
                      <div className="InfoCollaborator" key={collaborator.id}>
                        <div className="EnunciateSummaryCollaborator">
                          <p className="NameCollaborator"> {collaborator.firstName}</p>
                          <div className="IconsEdit">
                            <button
                              type="button"
                              className="ButtonEditDelete"
                              onClick={() => {
                                setIsOpenEditCollaborator(true);
                                setCollaboratorSelected(collaborator);
                              }}>
                              <Iconedit />
                            </button>
                            <button
                              type="button"
                              className="ButtonEditDelete"
                              onClick={() => {
                                setIsOpenDeleteCollaborator(true);
                                setCollaboratorSelected(collaborator);
                              }}>
                              <Icontrash />
                            </button>
                          </div>
                        </div>
                        <div className="SummaryInfoCollaborators">
                          <div className="InfoEmailCollaborators">
                            <p>{collaborator.email}</p>
                          </div>
                          <div className="cntInfoProfile">
                            {collaborator.departmentName && (
                              <p>
                                Departamento:
                                <Tooltip disableInteractive title={collaborator.departmentName}>
                                  <span>{collaborator.departmentName}</span>
                                </Tooltip>
                              </p>
                            )}

                            {collaborator.profileName && (
                              <p>
                                Perfil:
                                <Tooltip disableInteractive title={collaborator.profileName}>
                                  <span>{collaborator.profileName}</span>
                                </Tooltip>
                              </p>
                            )}
                          </div>

                          <div className="cntInfoProfile">
                            {collaborator.branchName && (
                              <p>
                                Filial:
                                <Tooltip disableInteractive title={collaborator.branchName}>
                                  <span> {collaborator.branchName}</span>
                                </Tooltip>
                              </p>
                            )}

                            {labelProfileType[
                              collaborator.profileType as unknown as ProfileType
                            ] && (
                              <p>
                                Tipo do Perfil:
                                <Tooltip
                                  disableInteractive
                                  title={
                                    labelProfileType[
                                      collaborator.profileType as unknown as ProfileType
                                    ]
                                  }>
                                  <span>
                                    {
                                      labelProfileType[
                                        collaborator.profileType as unknown as ProfileType
                                      ]
                                    }
                                  </span>
                                </Tooltip>
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <Grid container padding="2rem" justifyContent="center">
                  <Typography justifyContent="center" align="center" color={colors.primary}>
                    Nenhum colaborador encontrado...
                  </Typography>
                </Grid>
              )
            ) : (
              <div className="SummaryControllerCollaborators">
                {collaboratorToTutorial.map((collaborator) => (
                  <div className="InfoCollaborator" key={collaborator.id}>
                    <div className="EnunciateSummaryCollaborator">
                      <p className="NameCollaborator"> {collaborator.firstName}</p>
                      <div className="IconsEdit">
                        <button
                          type="button"
                          className="ButtonEditDelete"
                          id="edit-collaborator"
                          onClick={() => {
                            setIsOpenEditCollaborator(true);
                            setCollaboratorSelected(collaborator);
                          }}>
                          <Iconedit />
                        </button>
                        <button
                          type="button"
                          className="ButtonEditDelete"
                          id="delete-collaborator"
                          onClick={() => {
                            setIsOpenDeleteCollaborator(true);
                            setCollaboratorSelected(collaborator);
                          }}>
                          <Icontrash />
                        </button>
                      </div>
                    </div>
                    <div className="SummaryInfoCollaborators">
                      <div className="InfoEmailCollaborators">
                        <p>{collaborator.email}</p>
                      </div>
                      <div className="cntInfoProfile">
                        {collaborator.departmentName && (
                          <p>
                            Departamento:
                            <Tooltip disableInteractive title={collaborator.departmentName}>
                              <span>{collaborator.departmentName}</span>
                            </Tooltip>
                          </p>
                        )}

                        {collaborator.profileName && (
                          <p>
                            Perfil:
                            <Tooltip disableInteractive title={collaborator.profileName}>
                              <span>{collaborator.profileName}</span>
                            </Tooltip>
                          </p>
                        )}
                      </div>

                      <div className="cntInfoProfile">
                        {collaborator.branchName && (
                          <p>
                            Filial:
                            <Tooltip disableInteractive title={collaborator.branchName}>
                              <span> {collaborator.branchName}</span>
                            </Tooltip>
                          </p>
                        )}

                        {labelProfileType[collaborator.profileType as unknown as ProfileType] && (
                          <p>
                            Tipo do Perfil:
                            <Tooltip
                              disableInteractive
                              title={
                                labelProfileType[collaborator.profileType as unknown as ProfileType]
                              }>
                              <span>
                                {
                                  labelProfileType[
                                    collaborator.profileType as unknown as ProfileType
                                  ]
                                }
                              </span>
                            </Tooltip>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </ContentSummary>
        </Container>
        <ModalDeleteCollaborator
          isOpen={isOpenDeleteCollaborator}
          runningTutorial={runningTutorial}
          onRequestClose={() => {
            setIsOpenDeleteCollaborator(false);
          }}
          currentCollaborator={collaboratorSelected ?? ({} as ICollaboratorViewModel)}
          onRequestRemoveCollaborator={handleRemoveCollaborator}
        />
        <ModalEditCollaborator
          isOpen={collaboratorSelected !== undefined && isOpenEditCollaborator}
          runningTutorial={runningTutorial}
          onRequestClose={() => {
            setCollaboratorSelected(undefined);
            setIsOpenEditCollaborator(false);
          }}
          onRequestUpdateCollaborator={handleUpdateCollaborator}
          currentCollaborator={collaboratorSelected ?? ({} as ICollaboratorViewModel)}
        />
      </Body>
    </>
  );
}
